<template>
  <div class="sy-accessory-img-detail">
    <template v-if="fileList && fileList.length">
      <!-- 只显示一张 -->
      <template v-if="firstImgOnly">
        <span
          v-for="file in fileList && fileList.slice(0, 1)"
          :key="file"
          class="image-item-one">
          <img :src="file.openUrl" alt="">
        </span>
      </template>
      <!-- 全部显示 -->
      <template v-else>
        <template v-if="miniMode">
          <div
            v-for="(file, idx) in fileList"
            :key="idx"
            class="image-item font-color-primary"
            @click="handlePreviewImg(file.openUrl || file.url)"
          >
            <div class="image-item-wrap">
              <img :src="file.openUrl || file.url" alt="">
            </div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(file, idx) in fileList"
            :key="idx"
            class="image-item"
          >
            <el-image
              :src="file.openUrl || file.url"
              :key="idx"
              class="font-color-primary"
              :preview-src-list="previewSrcList">
              <div slot="placeholder" class="image-slot">
                {{pageText.loading}}<span class="dot">...</span>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </template>
      </template>
    </template>
    <template v-else>-</template>
    <el-dialog append-to-body :title="pageText.picturePreview" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    firstImgOnly: {type: Boolean, default: false},
    miniMode: {type: Boolean, default: false},
    fileList: {type: Array, default: () => []},
    pageText: {type: Object, default: () => ({})}
  },
  computed: {
    previewSrcList () {
      return this.fileList.map(i => i.openUrl || i.url) || []
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  methods: {
    // 图片预览
    handlePreviewImg (url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.sy-accessory-img-detail {
  display: inline-block;
  max-width: 100%;
}
.image-item {
  display: inline-block;
  margin: 0px 8px 8px 0px;
  .el-image {
    width: 60px;
    height: 60px;
    line-height: 58px;
    border: 1px solid #eee;
    overflow: hidden;
    text-align: center;
    &:hover {
      border-color: currentColor;
    }
    ::v-deep .el-image__inner {
      width: initial;
      height: initial;
      max-width: 60px;
      max-height: 60px;
      object-fit: contain;
      vertical-align: middle;
    }
    ::v-deep .el-image-viewer__wrapper {
      .el-image-viewer__mask {
        opacity: 0.8;
      }
      .el-image-viewer__close {
        color: #fff;
      }
    }
  }
  .image-item-wrap {
    width: 60px;
    height: 60px;
    line-height: 58px;
    border: 1px solid #eee;
    overflow: hidden;
    text-align: center;
    &:hover {
      border-color: currentColor;
    }
    img {
      width: initial;
      height: initial;
      max-width: 60px;
      max-height: 60px;
      object-fit: contain;
      vertical-align: middle;
    }
  }
}
.image-item-one {
  display: inline-block;
  height: 40px;
  img {
    vertical-align: text-top;
    height: 100%;
    object-fit: contain;
  }
}
</style>